import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const quickLinks = [
  { label: "角色资料库", to: "/roles" },
  { label: "动漫资讯", to: "/news" },
  { label: "社区交流", to: "/community" },
  { label: "关于我们", to: "/about" }
];

const categoryLinks = ["萌系角色", "冷系角色", "元气角色", "治愈角色", "优雅角色"];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg dark:text-foreground-950"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">萝莉</span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-600">
              {siteInfo.slogan}，为你整理每一份角色资料与作品解读。
            </p>
            <div className="mt-4 flex gap-2">
              {[
                { icon: "ri-weibo-fill", label: "微博" },
                { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
                { icon: "ri-qq-fill", label: "QQ群" }
              ].map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition-colors hover:text-primary-600"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base text-foreground-950">快速导航</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base text-foreground-950">热门分类</h4>
            <ul className="space-y-2.5">
              {categoryLinks.map((c) => (
                <li key={c}>
                  <Link
                    to={`/roles?tag=${encodeURIComponent(c.replace("角色", ""))}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base text-foreground-950">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-foreground-400"></i>
                <span>{siteInfo.address}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-group-line mt-0.5 text-foreground-400"></i>
                <span>{siteInfo.qq}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 {siteInfo.fullName} · 本站为演示项目，内容均为虚构示例</p>
          <p className="flex items-center gap-1">
            用心整理每一份二次元内容
            <i className="ri-heart-3-fill text-primary-400"></i>
          </p>
        </div>
      </div>
    </footer>
  );
}